import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const Header = styled('header')(({ theme }) => ({
  width: '100%',
  position: 'sticky',
  zIndex: 1000,
  top: 0,
  backgroundColor: theme.palette.mainLight,
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  height: '70px',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '20px!important',
  paddingRight: '32px!important',
  borderBottom: `1px solid ${theme.palette.borderColor}`,
  [theme.breakpoints.down('sm')]: {
    height: 60,
  },
}));

export { Header, HeaderContainer };
